exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._32yCE-c8-ViewOrganizationsTable-module-orgs-table .lcpMCVLg-ViewOrganizationsTable-module-td._2fg5Egm2-ViewOrganizationsTable-module-orgs-table-td{border-color:#aaa;padding-left:15px;padding-right:15px}._32yCE-c8-ViewOrganizationsTable-module-orgs-table ._1M2flCKd-ViewOrganizationsTable-module-th._3C7VPDNT-ViewOrganizationsTable-module-orgs-table-th{border-color:#aaa}._32yCE-c8-ViewOrganizationsTable-module-orgs-table ._2fg5Egm2-ViewOrganizationsTable-module-orgs-table-td._1TQC2Oiu-ViewOrganizationsTable-module-wrap{white-space:normal}", ""]);

// exports
exports.locals = {
	"primary": "#067370",
	"orgs-table": "_32yCE-c8-ViewOrganizationsTable-module-orgs-table",
	"orgsTable": "_32yCE-c8-ViewOrganizationsTable-module-orgs-table",
	"td": "lcpMCVLg-ViewOrganizationsTable-module-td",
	"orgs-table-td": "_2fg5Egm2-ViewOrganizationsTable-module-orgs-table-td",
	"orgsTableTd": "_2fg5Egm2-ViewOrganizationsTable-module-orgs-table-td",
	"th": "_1M2flCKd-ViewOrganizationsTable-module-th",
	"orgs-table-th": "_3C7VPDNT-ViewOrganizationsTable-module-orgs-table-th",
	"orgsTableTh": "_3C7VPDNT-ViewOrganizationsTable-module-orgs-table-th",
	"wrap": "_1TQC2Oiu-ViewOrganizationsTable-module-wrap"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/pages/Admin/sections/Organizations/ViewOrganizations/ViewOrganizationsTable/ViewOrganizationsTable.module.scss
// module id = 1200
// module chunks = 0